module.exports = __webpack_public_path__ + "png/balance2.png?4c610b8e892831d007ad23329c517d88";